/* eslint-disable */

export enum ProductRequestType {
  INVESTING_DISCLOSURES = "INVESTING_DISCLOSURES",
  DISPUTE = "DISPUTE",
}

/** TODO: Move all other reset APIs to use this enum */
export enum SponsorshipLimitUpdateType {
  RESET = "RESET",
  ADD_SINGLE = "ADD_SINGLE",
  EXHAUST_ALL_ATTEMPTS = "EXHAUST_ALL_ATTEMPTS",
}

export interface GetSponsorshipsRequest {
  customer_token?: string;
  include_transitions?: boolean;
  /**
   * When a sponsored period is provided using the sponsored_period_filter,
   * the GetSponsorships endpoint will only return dependents and sponsors
   * that participated in established sponsored accounts (states: Active or Suspended)
   * during the provided time period.
   */
  sponsored_period_filter?: SponsorshipPeriod;
}

export interface GetSponsorshipsResponse {
  sponsorships?: Sponsorships;
}

export interface GetProductRequestsRequest {
  sponsored_account_token?: string;
}

export interface GetProductRequestsResponse {
  product_requests?: ProductRequest[];
}

export interface ProductRequest {
  sponsored_account_token?: string;
  product_request_token?: string;
  state?: ProductRequestState;
  request_type?: ProductRequestType;
  created_at?: number;
  updated_at?: number;
  last_requested_at?: number;
  requesting_customer_token?: string;
  sponsor_activity_id?: number;
  sponsor_activity_added_at?: number;
  sponsor_activity_removed_at?: number;
  dependent_activity_id?: number;
  dependent_activity_added_at?: number;
  dependent_activity_removed_at?: number;
  transitions?: ProductRequestStateTransition[];
}

export enum ProductRequestState {
  PENDING = "PENDING",
  CANCELED = "CANCELED",
  COMPLETED = "COMPLETED",
}

export interface ProductRequestStateTransition {
  product_request_state_transition_token?: string;
  state?: ProductRequestState;
  previous_state?: ProductRequestState;
  state_reason?: string;
  transition_by_customer_token?: string;
  created_at?: number;
}

export interface GetSponsorshipPeriodsGivenSponsorRequest {
  sponsor_customer_token?: string;
}

export interface SponsorshipPeriod {
  start?: number;
  end?: number;
}

export interface SponsorshipPeriods {
  periods?: SponsorshipPeriod[];
}

export interface GetSponsorshipPeriodsGivenSponsorResponse {
  sponsorship_periods_by_sponsored_customer?: { [key: string]: SponsorshipPeriods };
}

export interface GetSponsorshipPeriodsGivenSponsorResponseSponsorshipPeriodsBySponsoredCustomerEntry {
  key: string;
  value?: SponsorshipPeriods;
}

export interface GetPreviouslyActiveDependentsForSponsorRequest {
  sponsor_customer_token?: string;
}

export interface GetPreviouslyActiveDependentsForSponsorResponse {
  previouslyActiveDependents?: string[];
}

export interface Sponsorships {
  sponsored_by?: Sponsorship[];
  sponsor_for?: Sponsorship[];
}

export interface Sponsorship {
  token?: string;
  state?: SponsorshipSTATE;
  dependent_customer_token?: string;
  sponsor_customer_token?: string;
  created_at?: number;
  updated_at?: number;
  transitions?: SponsorshipStateTransition[];
}

export enum SponsorshipSTATE {
  PENDING = "PENDING",
  ACTIVE = "ACTIVE",
  CANCELED = "CANCELED",
  SUSPENDED = "SUSPENDED",
}

export interface SponsorshipStateTransition {
  token?: string;
  state?: SponsorshipSTATE;
  previous_state?: SponsorshipSTATE;
  state_reason?: string;
  flow_token?: string;
  created_at?: number;
}

export interface CancelSponsorshipRequest {
  sponsored_account_token?: string;
  reason?: CancelSponsorshipRequestReason;
}

export enum CancelSponsorshipRequestReason {
  SPONSOR_DECLINED = "SPONSOR_DECLINED",
  SPONSOR_ACCOUNT_CLOSED = "SPONSOR_ACCOUNT_CLOSED",
  SUPPORT_CANCELED = "SUPPORT_CANCELED",
  SPONSOR_INELIGIBLE = "SPONSOR_INELIGIBLE",
  SPONSORED_ELSEWHERE = "SPONSORED_ELSEWHERE",
  ISSUER_ACCOUNT_LINKS_FAILED = "ISSUER_ACCOUNT_LINKS_FAILED",
  DEPENDENT_CANCELED_REQUEST = "DEPENDENT_CANCELED_REQUEST",
  REQUEST_EXPIRED = "REQUEST_EXPIRED",
  DEPENDENT_ACCOUNT_CLOSED = "DEPENDENT_ACCOUNT_CLOSED",
}

export interface CancelSponsorshipResponse {
  dependent_customer_token?: string;
  sponsor_customer_token?: string;
  status?: CancelSponsorshipResponseStatus;
}

export enum CancelSponsorshipResponseStatus {
  SUCCESS = "SUCCESS",
  FAILURE = "FAILURE",
}

export interface ApproveSponsorshipRequest {
  sponsored_account_token?: string;
}

export interface ApproveSponsorshipResponse {
  status?: ApproveSponsorshipResponseStatus;
}

export enum ApproveSponsorshipResponseStatus {
  SUCCESS = "SUCCESS",
  FAILURE = "FAILURE",
}

export interface ResendRequestSponsorshipNotificationRequest {
  sponsored_account_token?: string;
}

export interface ResendRequestSponsorshipNotificationResponse {
  status?: ResendRequestSponsorshipNotificationResponseStatus;
}

export enum ResendRequestSponsorshipNotificationResponseStatus {
  SUCCESS = "SUCCESS",
  FAILURE = "FAILURE",
}

export interface CreateOrUpdateSponsorshipRequest {
  customer_token?: string;
  status?: CreateOrUpdateSponsorshipRequestSponsorshipStatus;
  request_source?: CreateOrUpdateSponsorshipRequestSponsorshipRequestSource;
  event_occurred_at?: number;
  sponsor_customer_token?: string;
}

export enum CreateOrUpdateSponsorshipRequestSponsorshipRequestSource {
  CARD_ONBOARDING = "CARD_ONBOARDING",
  P2P = "P2P",
  PAPERMONEY_DEPOSIT = "PAPERMONEY_DEPOSIT",
  DEBIT_CASH_IN = "DEBIT_CASH_IN",
  FAMILY_ACCOUNT_NULL_STATE = "FAMILY_ACCOUNT_NULL_STATE",
  INVITE_LINK = "INVITE_LINK",
  INVESTING = "INVESTING",
  CRYPTO = "CRYPTO",
  GIFT_CARD = "GIFT_CARD",
  IDENTITY_HUB = "IDENTITY_HUB",
}

export enum CreateOrUpdateSponsorshipRequestSponsorshipStatus {
  PENDING = "PENDING",
  SPONSORED = "SPONSORED",
  SUSPENDED = "SUSPENDED",
  UNSPONSORED = "UNSPONSORED",
}

export interface CreateOrUpdateSponsorshipResponse {
  result?: CreateOrUpdateSponsorshipResponseResult;
}

export enum CreateOrUpdateSponsorshipResponseResult {
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
}

export interface ResetSponsorshipRequestLimitRequest {
  customer_token?: string;
}

export interface ResetSponsorshipRequestLimitResponse {
  status?: ResetSponsorshipRequestLimitResponseStatus;
}

export enum ResetSponsorshipRequestLimitResponseStatus {
  SUCCESS = "SUCCESS",
  FAILURE = "FAILURE",
}

export interface ResetSponsorSsnLimitRequest {
  customer_token?: string;
  reset_operation?: ResetSponsorSsnLimitRequestResetOperation;
}

export enum ResetSponsorSsnLimitRequestResetOperation {
  /** RESET_TO_0 - removes the entire counts */
  RESET_TO_0 = "RESET_TO_0",
  /** RESET_TO_MAX - essentially disables this SSN from sponsoring again */
  RESET_TO_MAX = "RESET_TO_MAX",
  /** GIVE_1_MORE - give 1 more capacity to the limit numbers */
  GIVE_1_MORE = "GIVE_1_MORE",
}

export interface ResetSponsorSsnLimitResponse {
  status?: ResetSponsorSsnLimitResponseStatus;
}

export enum ResetSponsorSsnLimitResponseStatus {
  SUCCESS = "SUCCESS",
  FAILURE = "FAILURE",
}

export interface HasSponsorExceededSsnLimitRequest {
  customer_token?: string;
}

export interface HasSponsorExceededSsnLimitResponse {
  has_exceeded_ssn_limit?: boolean;
}

export interface SyncSponsorshipRequest {
  sponsored_account_token?: string;
  force_update?: boolean;
}

export interface SyncSponsorshipResponse {
  status?: SyncSponsorshipResponseStatus;
}

export enum SyncSponsorshipResponseStatus {
  SUCCESS = "SUCCESS",
  FAILURE = "FAILURE",
}

/**
 * Kick off the product request (ie parental investing disclosures) life cycle.
 * This will create a record if a pending product request for the given request_type
 * does not exist and produce side effects (i.e. SMS/Push/Activity) rendered by
 * aegis. A product request is scoped to the sponsorship. Each sponsorship can have only
 * one product request of a given type.
 */
export interface InitiateProductRequestRequest {
  dependent_customer_token?: string;
  request_type?: ProductRequestType;
  /** which customer is requesting (in most cases, the current customer from the flowHistory) */
  requesting_customer_token?: string;
  /**
   * Used to determine what side effects to execute depending on where this
   * request is coming from
   */
  context?: InitiateProductRequestRequestContext;
  /**
   * Unique instance ID if there can exist multiple product requests for a given type
   * For example, if a sponsor can have multiple dispute requests at a time, a disputeId can differentiate them
   */
  external_instance_id?: string;
}

export interface InitiateProductRequestRequestContext {
  /** if true, indicates that this request originated from a sponsorship request flow */
  associated_with_sponsorship_request?: boolean;
  /** which sponsored_account this should be associated with */
  sponsored_account_token?: string;
  /**
   * The url to resume what the dependent customer was trying to do. When the dependent
   * gets notified about the approval, this link should allow them to resume
   */
  resume_client_route?: string;
}

export interface InitiateProductRequestResponse {
  status?: InitiateProductRequestResponseStatus;
  /**
   * Used for bookkeeping purposes, ie later if an upstream caller wants to query
   * on the state of a given product request
   */
  product_request_token?: string;
}

export enum InitiateProductRequestResponseStatus {
  SUCCESS = "SUCCESS",
  FAILURE = "FAILURE",
}

/** Complete or transition an existing product request to a terminal state. */
export interface CompleteProductRequestRequest {
  product_request_token?: string;
  dependent_customer_token?: string;
  request_type?: ProductRequestType;
  status?: CompleteProductRequestRequestStatus;
  /** which customer is requesting completion (in most cases, the current customer from the flowHistory) */
  requesting_customer_token?: string;
  /**
   * Unique instance ID if there can exist multiple product requests for a given type
   * For example, if a sponsor can have multiple dispute requests at a time, a disputeId can differentiate them
   */
  external_instance_id?: string;
}

export enum CompleteProductRequestRequestStatus {
  SUCCESS = "SUCCESS",
  CANCELED = "CANCELED",
  FAILED = "FAILED",
}

export interface CompleteProductRequestResponse {
}

/** Add entry points for graduation (used for testing) */
export interface AddGraduationEntryPointsRequest {
  dependent_customer_token?: string;
  force_send?: boolean;
}

export interface AddGraduationEntryPointsResponse {
  status?: AddGraduationEntryPointsResponseStatus;
}

export enum AddGraduationEntryPointsResponseStatus {
  SUCCESS = "SUCCESS",
  FAILURE = "FAILURE",
}

export interface GetEligibleForGraduationRequest {
  customer_token?: string;
}

export interface GetEligibleForGraduationResponse {
  eligible?: boolean;
}

export interface GetInvitationsRequest {
  customer_token?: string;
}

export interface GetInvitationsResponse {
  invitations?: Invitations;
}

export interface Invitations {
  invitation?: Invitation[];
}

export interface Invitation {
  external_token?: string;
  external_status?: InvitationStatus;
  invitation_type?: InvitationType;
  created_at?: number;
  updated_at?: number;
  request_source?: InvitationRequestSource;
  inviter_customer_token?: string;
  invitee_customer_token?: string;
}

export enum InvitationStatus {
  UNKNOWN = "UNKNOWN",
  PENDING = "PENDING",
  LINKED = "LINKED",
  ACCEPTED = "ACCEPTED",
  DECLINED = "DECLINED",
  EXPIRED = "EXPIRED",
  CANCELED = "CANCELED",
}

export enum InvitationType {
  DEPENDENT_INITIATED = "DEPENDENT_INITIATED",
  SPONSOR_INITIATED = "SPONSOR_INITIATED",
}

export enum InvitationRequestSource {
  CARD_ONBOARDING = "CARD_ONBOARDING",
  P2P = "P2P",
  PAPERMONEY_DEPOSIT = "PAPERMONEY_DEPOSIT",
  DEBIT_CASH_IN = "DEBIT_CASH_IN",
  FAMILY_ACCOUNT_NULL_STATE = "FAMILY_ACCOUNT_NULL_STATE",
  INVITE_LINK = "INVITE_LINK",
  INVESTING = "INVESTING",
  CRYPTO = "CRYPTO",
  GIFT_CARD = "GIFT_CARD",
  IDENTITY_HUB = "IDENTITY_HUB",
}

export interface PrivacyVaultEntity {
}

export enum PrivacyVaultEntityType {
  CUSTOMER = "CUSTOMER",
}

/** Will return applicable limits depending on customer type (dependent or sponsor) */
export interface GetSponsorshipLimitsRequest {
  customer_token?: string;
}

export interface GetSponsorshipLimitsResponse {
  sponsorship_limits?: SponsorshipLimits;
}

export interface SponsorshipLimits {
  sponsorship_limit?: SponsorshipLimit[];
}

export interface SponsorshipLimit {
  customer_token?: string;
  sponsorship_limit_type?: string;
  has_exceeded?: boolean;
}

export interface UpdateSponsorshipLimitRequest {
  customer_token?: string;
  sponsorship_limit_type?: string;
  update_type?: SponsorshipLimitUpdateType;
}

export interface UpdateSponsorshipLimitResponse {
  status?: UpdateSponsorshipLimitResponseStatus;
}

export enum UpdateSponsorshipLimitResponseStatus {
  SUCCESS = "SUCCESS",
  FAILURE = "FAILURE",
}
